import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringService {
  /** Converts Sentence Case string to sentenceCaseString */
  toCamelCase(sentenceCase: string): string {
    return sentenceCase
      .toLocaleLowerCase()
      .replace(/(?:^.|[A-Z]|\b.)/g, (letter: string, index: number): string => {
        return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
      })
      .replace(/\s+/g, '');
  }

  /** Converts any whole string (no spaces) to kebab-case-string */
  toKebabCase(camelCase: string | undefined): string {
    if (!camelCase) {
      return '';
    }

    return camelCase.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
  }

  /**
   * Appends a suffix to the end of a number
   * @param num Number the suffix will be appended to
   */
  displayWithNumberSuffix(num: number | string): string {
    const number = num.toString();

    return number.endsWith('11')
      ? number + 'th'
      : number.endsWith('12')
        ? number + 'th'
        : number.endsWith('13')
          ? number + 'th'
          : number.endsWith('1')
            ? number + 'st'
            : number.endsWith('2')
              ? number + 'nd'
              : number.endsWith('3')
                ? number + 'rd'
                : number + 'th';
  }

  /**
   * Joins an array into a human-readable sentence-like list.
   * Originally for recurring session designs, which did not have an Oxford comma,
   * so it's not supported yet.
   * @param text words to combine together
   * @returns Mondays
   * @returns Mondays & Fridays
   * @returns Mondays, Wednesdays & Fridays
   */
  sentenceJoin(text: string[]): string {
    if (text.length === 0) {
      return '';
    }

    if (text.length === 1) {
      return text[0];
    }

    const lastItem = text.slice(-1);
    const remainingItems = text.slice(0, -1);
    return [remainingItems.join(', '), lastItem].join(' & ');
  }
}
